import { render, staticRenderFns } from "./ShowCheck.vue?vue&type=template&id=048a9cf0"
import script from "./ShowCheck.vue?vue&type=script&lang=js"
export * from "./ShowCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports